import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from 'src/app/service/utility.service';
import { SurveyService } from '../service/survey.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {
  public details: any = [];
  public suvDetails: any = {};
  public quotas: any = [];
  public tGroup: any = [];
  // public showAllContainers: any = ['All','Container-1 (Active)','Container-2 (Inactive)','Container-3 (Expired)','Container-4 (Active)'];
  public containers_arr: any = []
  public containerHoverIndex = -1;


  constructor(
    public surveyService:SurveyService,
    public route:Router,
    private cd: ChangeDetectorRef,
    public activeRoute:ActivatedRoute,
    public utility:UtilityService
  ) { }

  ngOnInit(): void {
    this.checkRedirectFrom();
    this.setFormFields();
    this.getSurvayDetails();

    // this.selectedContainer();
    // console.log(this.surveyService.surveyReport,'Hiiiiiiii');
  }
  ngOnDestroy(): void{
    this.surveyService.defaultSurveyGetLink = 1;
  }


  checkRedirectFrom(){
    if(localStorage.getItem('redirectFromCompletionSurveyDetails')){
      this.surveyService.redirectFromCompletion = true;
      this.surveyService.redirectFromInventory = false;
      let surveyDeatils:any = localStorage.getItem('redirectFromCompletionSurveyDetails');
      surveyDeatils = JSON.parse(surveyDeatils);
      this.surveyService.redirectFromCompletionSurveyDetails = surveyDeatils;
    }
    else
    {
      this.surveyService.redirectFromCompletion = false;
      this.surveyService.redirectFromInventory = true;
      this.surveyService.selected_container = {'container_name':'Container All','status':'Active','container_id':''};
    }
  }




    

  setFormFields() {
    this.details = [
      {name:'Survey Name',key:'survey_name',value:"Abcd"},
      {name:'Expected LOI',key:'expected_cpi',value:"15%"},
      {name:'Start Date',key:'start_date',value:"12 Jan 2022"},
      {name:'Expected IR',key:'expected_ir',value:"12%"},
      {name:'End Date',key:'end_date',value:"12 Feb 2022"},
      {name:'Sample Size',key:'sample_size',value:"75/100"},
      {name:'Expected CPI',key:'expected_cpi',value:"12"}
    ];
    this.quotas = [
      {name:'Delhi NCR',required:'250',completed:"150"},
      {name:'Male',required:'128',completed:"99"},
      {name:'Female',required:'140',completed:"112"},
      {name:'25 - 35',required:'70',completed:"43"}
    ];
    this.tGroup = [
      {name:'City',key:'city',value:"Delhi NCR"},
      {name:'Gender',key:'gender',value:"Male"},
      {name:'Age',key:'age',value:"24"},
    ]
  }
  detailsRouterChange(){
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
    // console.log(survey_id,'sURVEYiD');
    this.route.navigate([`/survey/details/${survey_id}`]);
  }
  quotaRouterChange(){
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
    // console.log(survey_id);
    this.route.navigate([`/survey/quota/${survey_id}`]);
  }

  tgQuotaRouterChange(){
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
    // console.log(survey_id);
    this.route.navigate([`/survey/target-group/${survey_id}`]);
  }
  // uploadRejectionRouterChange(){
  //   let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
  //   this.route.navigate([`/survey/operations/${survey_id}`]);
  // }

  getSurvayDetails(){
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
    let container_id = "";
    if(localStorage.getItem('selected_container')){
      let selected_container:any = localStorage.getItem('selected_container');
      selected_container = JSON.parse(selected_container);
      this.surveyService.selected_container =selected_container;
      container_id = selected_container.container_id;
    }
    this.surveyService.getSurvayDetails(survey_id,container_id)
    .subscribe({
      next: (res: any) =>{
        if (res['status'] == 1) {
          this.suvDetails = res.result;
          this.suvDetails['total_sample_size'] = ( res.result.achieved_sample || '0') + "/" + (res.result.sample_size || '0');
          this.suvDetails['crownit_sample_size'] = ( res.result.crownit_achieved_sample || '0') + "/" + (res.result.crownit_sample_size	 || '0');
          // this.surveyService.surveyDetails = res['result'];
          this.surveyService.surveyDetails = this.suvDetails;
          this.surveyService.setContainers(this.suvDetails);
          this.surveyService.selectedContainer();
          this.cd.detectChanges();
        }
      },error :(e) =>{
        console.log(e)
      }
    })
  }





  


  getLinkDetails(flag:number){
    if(flag === 0)
    {
      let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
      this.surveyService.getDownloadLinkDetails(survey_id,1)
      .subscribe({
        next: (res: any) =>{
          if (res['status'] == 1) {
            this.surveyService.SurveyGetLink = res['links'];
            this.cd.detectChanges();
            this.utility.copyOnClick(res['links'][0]);
  
          }
        },error :(e) =>{
          console.log(e)
        }
      })
    }
    else
    {
      let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
      this.surveyService.getDownloadLinkDetails(survey_id,this.surveyService.defaultSurveyGetLink)
      .subscribe({
        next: (res: any) =>{
          if (res['status'] == 1) {
            this.surveyService.SurveyGetLink = res['links'];
            this.cd.detectChanges();
            // this.utility.copyOnClick(res['links'][0]);
            this.surveyService.downloadLink(res['links']);
          }
        },error :(e) =>{
          console.log(e)
        }
      })

    }
  }
  getTestLinkDetails(link:any){
    this.utility.copyOnClick(link)
  }

  changeContainerBgColor(index:any){
    this.containerHoverIndex = index;
   
  }


  switchContainerCall(item:any){
    this.surveyService.selected_container = item;
    localStorage.setItem('selected_container',JSON.stringify(item));
    this.getSurvayDetails();
  }


 

 


  // getSurveyDetailsPid(){
  //   return this.surveyService.redirectFromCompletionSurveyDetails.rid;
  // }

  // getCagsDeatils(){
  //   let cag = this.surveyService.redirectFromCompletionSurveyDetails.cags;
  //   let str = "";
  //   str += cag['Age'][0] +','+ cag['Gender'][0] +',' +  cag['City'][0];
  //   return str;
  // }

}
